if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // jouw mini cart
        this.cart = document.querySelector('mini-cart');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.cache = 'no-store';

        const formData = new FormData(this.form);

        // ✅ SECTIONS GOED MEEGEVEN
        if (this.cart) {
          formData.set(
            'sections',
            this.cart.getSectionsToRender().map((s) => s.id).join(',')
          );

          formData.set('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        try {
          /* ===============================
             1️⃣ ADD TO CART
          =============================== */
          const addRes = await fetch(theme.routes.cart_add_url, config);
          const response = await addRes.json();

          // ❌ foutmelding (sold out etc.)
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          }

          // geen mini cart → normale cart pagina
          if (!this.cart) {
            window.location = theme.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });

          this.error = false;

          /* ===============================
             2️⃣ DIRECT RENDER
          =============================== */
          this.cart.renderContents(response);

          /* ===============================
             3️⃣ FORCE REFRESH (BELANGRIJK)
             haalt verse sections op zoals +/-
          =============================== */
          const sectionIds = this.cart
            .getSectionsToRender()
            .map((s) => s.id)
            .join(',');

          const sectionRes = await fetch(
            `${theme.routes.cart_url}?sections=${sectionIds}&_=${Date.now()}`,
            { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } }
          );

          const sections = await sectionRes.json();

          this.cart.renderContents({
            ...response,
            sections,
          });
        } catch (e) {
          console.error(e);
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
          }
        }
      }

      /* ===============================
         VALIDATIE
      =============================== */

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error('Expected a form element.');
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;

        for (const field of requiredFields) {
          const belongsToForm =
            field.getAttribute('form') === formId ||
            field.closest('form')?.id === formId;

          if (!belongsToForm) continue;

          if (!field.value || field.value.trim() === '') {
            field.classList.add('invalid');
            allFilled = false;
          } else {
            field.classList.remove('invalid');
          }
        }

        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage('Vul alle verplichte velden in.');
          return false;
        }

        return true;
      }

      /* ===============================
         ERROR HANDLING
      =============================== */

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
